import { useState } from 'react';
import { Toast } from '@tencent/calendar-web-component-mobile';
import { uploadToCos, base64ToFile } from 'src/utils/upload-cos';

function useCropper() {
  const [modalVisible, setModalVisible] = useState(false); // 裁剪弹窗显示
  const [selectFile, setSelectFile] = useState({} as any); // 选择的文件
  const [fileUrl, setFileUrl] = useState(''); // 传给裁剪组件的本地fileurl
  const [fileName, setFileName] = useState(''); // filename 属性不为空时才会渲染文件信息
  const [imageUrl, setImageUrl] = useState(''); // 预览图
  const [uploadStatus, setUploadStatus] = useState<any>(); // 上传状态

  // 裁剪完成，点击确认
  const handleModalConfirm = (str: string) => {
    setModalVisible(false);
    setUploadStatus('validating');
    const newFile = base64ToFile(str, selectFile.name);
    // 开始上传图片
    return uploadToCos(newFile, true).then(
      (cosData) => {
        setUploadStatus('');
        setImageUrl(str);
        setFileName(selectFile.name);
        return {
          url: cosData.cosUrl || str,
          cosId: cosData.cosId,
        };
      },
      (err) => {
        if (typeof err === 'string') {
          Toast.fail(err);
        } else {
          Toast.fail('上传失败，请检查您的网络');
        }
        setUploadStatus('');
        return Promise.reject(err);
      },
    );
  };

  // 取消裁剪上传
  const handleModalCancel = () => {
    setModalVisible(false);
  };
  return {
    modalVisible,
    setModalVisible,
    selectFile,
    fileUrl,
    handleModalConfirm,
    handleModalCancel,
    fileName,
    setFileName,
    imageUrl,
    uploadStatus,
    setFileUrl,
    setSelectFile,
  };
}

export default useCropper;
